const isDev = process.env.NODE_ENV === 'development';

// export const APP_API_URL = isDev ? '' : '';
export const APP_API_URL = isDev ? '' : '';
